"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/popover/style");
var _popover = _interopRequireDefault(require("antd/lib/popover"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _BanTag = _interopRequireDefault(require("./BanTag"));
var _BanOption = _interopRequireDefault(require("./BanOption"));
var _UnbanOption = _interopRequireDefault(require("./UnbanOption"));
var _constants = require("./constants");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isOptionVisible = function isOptionVisible(isCurrentUserAdmin, option, member) {
  var isDisplayed = option.display ? option.display(member) : true;
  var isAccessible = isCurrentUserAdmin || !option.adminOnly;
  return isDisplayed && isAccessible;
};
var Member = function Member(_ref) {
  var chatUser = _ref.chatUser,
    member = _ref.member,
    channelId = _ref.channelId,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Settings' : _ref$title,
    _ref$onChangeBan = _ref.onChangeBan,
    onChangeBan = _ref$onChangeBan === void 0 ? _lodash.noop : _ref$onChangeBan,
    _ref$showInfo = _ref.showInfo,
    showInfo = _ref$showInfo === void 0 ? true : _ref$showInfo;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    optionsPopoverShown = _useState2[0],
    setOptionsPopoverShown = _useState2[1];
  var isCurrentUserAdmin = chatUser.role === 'admin';
  var user = member.user;
  // user.banned is banned globally, member.banned is banned in channel
  var banned = user.banned || member.banned;
  var settingsOptions = (0, _react.useMemo)(function () {
    var banOptions = channelId ? _constants.MEMBER_CHANNEL_BAN_OPTIONS : _constants.MEMBER_ACCOUNT_BAN_OPTIONS;
    var unbanOptions = channelId ? _constants.MEMBER_CHANNEL_UNBAN_OPTIONS : _constants.MEMBER_ACCOUNT_UNBAN_OPTIONS;
    return banned ? unbanOptions.filter(function (option) {
      return isOptionVisible(isCurrentUserAdmin, option, member);
    }) : banOptions.filter(function (option) {
      return isOptionVisible(isCurrentUserAdmin, option, member);
    });
  }, [member, banned, channelId]);
  var userId = member.user_id;
  var isSettingsAvailable = !(0, _lodash.isEmpty)(settingsOptions) && chatUser.id !== userId;
  var banTags = /*#__PURE__*/_react.default.createElement(_BanTag.default, {
    banned: banned,
    banExpires: member.ban_expires,
    inChannel: !!channelId
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-member"
  }, showInfo && /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-member__name"
  }, /*#__PURE__*/_react.default.createElement("span", null, member.user.name), banTags), /*#__PURE__*/_react.default.createElement(_popover.default, {
    title: title,
    trigger: "click",
    visible: isSettingsAvailable ? optionsPopoverShown : false,
    onVisibleChange: function onVisibleChange(visible) {
      return setOptionsPopoverShown(visible);
    },
    content: settingsOptions.map(function (option, key) {
      return banned ? /*#__PURE__*/_react.default.createElement(_UnbanOption.default, {
        userId: userId,
        channelId: channelId,
        userBanned: user.banned,
        memberBanned: member.banned,
        option: option,
        isCurrentUserAdmin: isCurrentUserAdmin,
        onBanSuccess: function onBanSuccess() {
          setOptionsPopoverShown(false);
          onChangeBan(userId);
        },
        banTags: banTags,
        key: key
      }) : /*#__PURE__*/_react.default.createElement(_BanOption.default, {
        userId: userId,
        channelId: channelId,
        option: option,
        onBanSuccess: function onBanSuccess() {
          setOptionsPopoverShown(false);
          onChangeBan(userId);
        },
        key: key
      });
    })
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "_custom",
    className: (0, _classnames.default)('icon-settings', {
      'text-alertred-60 fill-alertred-60': banned
    }),
    style: isSettingsAvailable ? {} : {
      cursor: 'not-allowed',
      opacity: 0.5
    }
  })));
};
var _default = Member;
exports.default = _default;